// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"style_sidebar__JZbWU"};